import { Component,Inject,OnInit } from '@angular/core';
import {DataInsightFacade} from '../../store/data-insight.facades'
import { Store } from '@ngrx/store';
import { selectDataInsight } from '../../store/data-insight.selectors';
import { SurveyState } from '../../../study-survey/store';
import { REGISTRY_APPLICATION } from '../../../global/tokens';

@Component({
  selector: 'lib-cq-data-insights',
  templateUrl: './cq-data-insights.component.html',
  styleUrls: ['./cq-data-insights.component.scss']
})
export class CqDataInsightsComponent {
  dataInsights$ = this.store.select(selectDataInsight);


  
  constructor(
    public dataInsightFacade: DataInsightFacade,
    private store: Store<SurveyState>,
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) {}

  ngOnInit(): void {
    if (this.application === 'Admin') {
      const userID = window.location.pathname.split('/user/')[1].split('/')[0];
      this.dataInsightFacade.dataInsightLoad(userID);
    } else {
      this.dataInsightFacade.dataInsightLoad();
    }
  }
 
}
